module.exports = __webpack_public_path__ + "static/img/3.9397225.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/3.png
// module id = RYnA
// module chunks = 0